"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("../BaseQuery");
var portal_1 = require("../../models/portal");
var dxm_1 = require("./provider/dxm");
var mpi_1 = require("./provider/mpi");
var ExternalApiQuery = /** @class */ (function (_super) {
    __extends(ExternalApiQuery, _super);
    function ExternalApiQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ExternalApiQuery.prototype, "providers", {
        get: function () {
            var _a;
            return _a = {},
                _a[portal_1.ProviderKey.MPI] = mpi_1.MpiProvider,
                _a[portal_1.ProviderKey.DXM] = dxm_1.DxmProvider,
                _a;
        },
        enumerable: true,
        configurable: true
    });
    ExternalApiQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('id', 'idQuery', executionOptions);
    };
    ExternalApiQuery.prototype.getOptions = function () {
        var _a = this.queryOptions.options, options = _a === void 0 ? {} : _a;
        return options.externalApi || {};
    };
    ExternalApiQuery.prototype.getRawValue = function (executionOptions, callStackLevel) {
        if (callStackLevel === void 0) { callStackLevel = 1; }
        var externalApiRequest = this.getExternalApiRequest(this.options, executionOptions);
        if (externalApiRequest) {
            var query = void 0;
            var providerKey = externalApiRequest.providerKey;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            var ProviderClass = this.providers[providerKey];
            var provider = void 0;
            if (ProviderClass) {
                provider = new ProviderClass(externalApiRequest);
            }
            if (provider) {
                query = provider.getQuery(this.queryOptions, this.translationHelper);
            }
            if (query) {
                return query.execute(executionOptions, callStackLevel + 1);
            }
        }
        return;
    };
    return ExternalApiQuery;
}(BaseQuery_1.BaseQuery));
exports.ExternalApiQuery = ExternalApiQuery;
//# sourceMappingURL=ExternalApiQuery.js.map